export const SYNTHETIC_DATASETS = {
  FETCH_SYNTHETIC_DATASETS: 'INTERNAL_ADMIN/SYNTHETIC_DATA/FETCH_SYNTHETIC_DATASETS',
  CREATE_SYNTHETIC_DATASETS: 'INTERNAL_ADMIN/SYNTHETIC_DATA/CREATE_SYNTHETIC_DATASETS',
};
